export default class SyntaxError extends Error {
  constructor(message, line, column) {
    const msg = `Syntax error: ${message} at line ${line}:${column}`;
    super(msg);
  }
}
